export enum VisitStatusEnum {
    None = "None",
    NotYetDue = "Not Yet Due",
    NotStarted = "Not Yet Started",
    //    completed
    SubmittedCoSignature = "Submitted Pending Co-Signature",
    SubmittedWithSignature = "Submitted with Signature", // Also known as pending QA
    SubmittedWithSignaturePal = "Submitted With Signature",
    ExportReady = "Export Ready",
    Exported = "Export Ready",
    ToBeSent = "To Be Sent",
    SentToPhysician = "Sent to Physician",
    ReturnedWithPhysicianSignature = "Returned with Physician Signature",
    Completed = "Completed",
    NotExported = "Not Exported",
    // saved
    Saved = "Saved",
    Returned = "Returned for Review",
    Reopened = "Reopened",
    Created = "Created",
    PendingAddendum = "Pending Addendum",
    ProcessingSubmission = "Processing",
    OrderReceived = "Order Received",
    MissedVisit = "Missed Visit"
}
